var React = require('react');

function PencilInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"m18 1 5 5L7 22H2v-5L18 1ZM4 17.828V20h2.172L17.336 8.836l-2.172-2.172L4 17.828ZM16.664 5.164l2.172 2.172L20.172 6 18 3.828l-1.336 1.336Z","clipRule":"evenodd"}));
}

PencilInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","role":"img","aria-label":""};

module.exports = PencilInline;

PencilInline.default = PencilInline;
